import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  addTag(event) {
    event.preventDefault()
    
    if (!this.hasContainerTarget) return
    
    const container = this.containerTarget
    const tagInputs = container.querySelectorAll('.tag-input-row')
    const lastInput = tagInputs[tagInputs.length - 1]?.querySelector('input[type="text"]')
    
    // Only add a new tag input if the last one has content
    if (lastInput && lastInput.value.trim() !== '') {
      const newRow = this.createTagInputRow()
      const addButton = container.querySelector('button[data-action*="addTag"]')
      if (addButton) {
        container.insertBefore(newRow, addButton)
      }
    }
  }

  removeTag(event) {
    event.preventDefault()
    
    const row = event.target.closest('.tag-input-row')
    if (!row) return
    
    const container = this.containerTarget
    const tagInputs = container.querySelectorAll('.tag-input-row')
    
    // Don't remove if it's the only row
    if (tagInputs.length > 1) {
      row.remove()
    } else {
      // Just clear the input if it's the last one
      const input = row.querySelector('input[type="text"]')
      if (input) {
        input.value = ''
      }
    }
  }

  createTagInputRow() {
    const div = document.createElement('div')
    div.className = 'flex items-center tag-input-row'
    div.innerHTML = `
      <input type="text" name="blog_post[tag_names][]" 
             class="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mr-2"
             placeholder="Enter tag name...">
      <button type="button" class="text-red-500 hover:text-red-700" data-action="click->tag-input#removeTag">
        <i class="ph-bold ph-x"></i>
      </button>
    `
    return div
  }
}
